import 'array.prototype.upsert';

export{};
declare global {
  interface Array<T> {
    upsert(primaryKey: any, key?: any, value?: any): Array<T>;
  }
}
